<template>
    <div class="form-privacy-policy">
        <p >
            Administratorem Pani/Pana danych osobowych jest MAKRO Cash and Carry Polska
            S.A. z siedzibą w Warszawie (02-183), Al. Krakowska 61 („MAKRO”).
        </p>
        <p>
            Pani/Pana dane będą przetwarzane w celu otrzymywania od MAKRO pod podany adres
            poczty elektronicznej (otrzymywanie wiadomości e-mail) i/lub numer telefonu
            (otrzymywanie wiadomości sms, mms oraz połączeń przychodzących), oznaczonych
            „Tak”, informacji o kampaniach marketingowych, ofertach specjalnych, usługach,
            promocjach i wydarzeniach organizowanych przez MAKRO, a także kontaktowania się
            na potrzeby badania opinii klientów. Podstawą prawną tego przetwarzania jest
            Pani/Pana zgoda a także prawnie uzasadniony interes MAKRO, którym jest
            informowanie klientów o ofertach i usługach MAKRO oraz o rozwijaniu współpracy
            z klientami.
        </p>
        <p>
            Pani/Pana dane mogą być przekazywane podwykonawcom MAKRO, w szczególności
            dostawcom rozwiązań informatycznych oraz agencjom marketingowym, w celu
            zapewnienia jak najwyższej jakości usług dopasowanych do Pani/Pana potrzeb.
        </p>
        <p>
            Pani/Pana dane będą przechowywane do czasu cofnięcia zgody (wniesienia
            sprzeciwu wobec ich przetwarzania). Okres przetwarzania danych może zostać
            każdorazowo przedłużony o okres przedawnienia roszczeń, jeżeli przetwarzanie
            danych osobowych będzie niezbędne dla dochodzenia ewentualnych roszczeń lub
            obrony przed takimi roszczeniami.
        </p>
        <p>
            Przysługuje Pani/Panu prawo dostępu do swoich danych oraz ich sprostowania,
            usunięcia, ograniczenia przetwarzania, jak również prawo do przenoszenia
            danych osobowych oraz prawo wniesienia skargi do organu nadzorczego zajmującego
            się ochroną danych osobowych, w przypadku uznania, że przetwarzanie danych
            osobowych narusza przepisy prawa. Ponadto, przysługuje Pani/Panu prawo do
            wniesienia sprzeciwu wobec przetwarzania danych osobowych na potrzeby marketingu
            bezpośredniego, w tym profilowania.
        </p>
        <p>
            Wyrażenie zgody jest dobrowolne i można ją wycofać w dowolnym momencie,
            zawiadamiając o tym MAKRO (np. pod adresem email:
            <a href='mailto:ochrona.danych@makro.pl'>ochrona.danych@makro.pl</a>, na stronie
            <a href='https://zgody.makro.pl/' target="_blank" rel="noopener">
                https://zgody.makro.pl/
            </a> lub osobiście w hali MAKRO). Cofnięcie zgody nie wpłynie na zgodność z
            prawem przetwarzania, którego dokonano na podstawie zgody przed jej wycofaniem.
            Nieudzielenie lub cofnięcie zgody nie wywiera dla Pani/Pana żadnych
            niekorzystnych konsekwencji.
        </p>
        <p>
            Pani/Pana dane mogą podlegać profilowaniu. Takie przetwarzanie danych ułatwia
            MAKRO lepsze poznanie Pani/Pana zainteresowań i potrzeb oraz umożliwia MAKRO
            uwzględnianie tych potrzeb i podejmowanie odpowiednich działań, np. komunikowanie
            się z Państwem w sposób zindywidualizowany. Pani/Pana dane nie będą przetwarzane
            w sposób zautomatyzowany, tj. bez ingerencji człowieka.
        </p>
        <p>
            Szczegółowe zasady dotyczące przetwarzania danych osobowych w MAKRO są opisane
            w „Polityce prywatności” dostępnej na stronie internetowej www.makro.pl lub w
            hali MAKRO. We wszelkich kwestiach związanych z przetwarzaniem danych osobowych
            przez MAKRO, w tym wycofaniem zgody, można kontaktować się z Inspektorem
            Ochrony Danych pod adresem email:
            <a href='mailto:ochrona.danych@makro.pl'>ochrona.danych@makro.pl</a>.
        </p>
    </div>
</template>
<script>
    export default {
        name: 'FormPricacyPolicy'
    }
</script>
